//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'

export default {
  data() {
    return { errors: {}, input: {}, isSubmitting: false }
  },

  methods: {
    async handleSubmit() {
      try {
        this.errors = {}
        this.isSubmitting = true
        const response = await this.$axios.post('v1/contact', this.input)

        this.$alert.requestSuccess(response)
      } catch (error) {
        this.errors = get(error, 'response.data.errors', {})
        this.$alert.requestError(error)
      } finally {
        this.isSubmitting = false
      }
    },
  },
}
